import { getDayJs } from '~/services/TimeService';

import { flagLabels } from './logic';
import { actionFlag, marginBandLabels, medianBand } from './marginBands';
import { CommandDeparture, CommandFlag, CostBasis } from './types';

export const departureActionOrder: CommandFlag[] = [
  'red',
  'amber',
  'empty',
  'early',
  'unavailable',
  'closed',
  'ltle copy',
  'handed back',
  'green',
];

export function departureActionGroups(rows: CommandDeparture[], basis: CostBasis) {
  const groups = departureActionOrder
    .map((flag) => ({ flag, rows: rows.filter((d) => actionFlag(d, basis) === flag) }))
    .filter((g) => g.rows.length);
  const actionable = groups.filter((g) => ['red', 'amber', 'empty'].includes(g.flag));
  return actionable.length ? actionable : groups;
}

export function departureActionReason(d: CommandDeparture, basis: CostBasis): string {
  const flag = actionFlag(d, basis);
  const band = medianBand(d, basis);
  return ['red', 'amber', 'green'].includes(flag) && band
    ? `${marginBandLabels[band]} median margin`
    : flagLabels[flag];
}

export function departureActionDetail(d: CommandDeparture, basis: CostBasis, includeTour = false): string {
  return `${includeTour ? `${d.opp_name} · ` : ''}${getDayJs(d.dep).format('D MMM YY')}: ${departureActionReason(d, basis)}`;
}
